import { useState } from "react";
import { Link } from "react-router-dom";
import API from "../api/axios";
import toast from "react-hot-toast";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await API.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Reset link sent if email exists");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={{ display: "flex", alignItems: "center", marginBottom: "`16px", userSelect:"none",  }}>
          <img
  src="/logo.png"
  alt="MartSense"
  style={{ width: "60px", height: "60px", objectFit: "contain", marginRight: "-8px", pointerEvents: "none", WebkitUserSelect: "none", }}
/>
           <span style={{ fontSize: "26px", fontWeight: "800", whiteSpace: "nowrap", letterSpacing: "-0.5px", userSelect: "none", WebkitUserSelect: "none", }}>
          <span style={{ color: "#2ec4b6" }}>Mart</span>
          <span style={{ color: "#f6a809" }}>Sense</span>
          </span>
        </div>
        {/* Hero image */}
<div style={{
  position: "relative",
  height: "180px",
  overflow: "hidden",
}}>
  <img
    src="/splash.JPG"
    alt="MartSense"
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "center top",
      display: "block",
    }}
  />
  <div style={{
    position: "absolute",
    bottom: "-2px", left: 0, right: 0,
    height: "50px",
    background: "#0f1a1a",
    borderRadius: "50% 50% 0 0 / 100% 100% 0 0",
  }} />
</div>
        {sent ? (
          <div style={styles.successBox}>
            <p style={styles.successIcon}>📧</p>
            <h2 style={styles.title}>Check your email</h2>
            <p style={styles.sub}>
              If that email is registered you will receive a password reset link shortly.
              Check your spam folder if you do not see it.
            </p>
            <Link to="/login" style={styles.backBtn}>Back to Login</Link>
          </div>
        ) : (
          <>
            <h1 style={styles.title}>Forgot Password</h1>
            <p style={styles.sub}>
              Enter your email and we will send you a reset link.
            </p>

            <form onSubmit={handleSubmit} style={styles.form}>
              <div style={styles.field}>
                <label style={styles.label}>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@business.com"
                  required
                  style={styles.input}
                />
              </div>
              <button type="submit" disabled={loading} style={styles.btn}>
                {loading ? "Sending..." : "Send Reset Link"}
              </button>
            </form>

            <p style={styles.footer}>
              Remember your password?{" "}
              <Link to="/login" style={styles.link}>Sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#0a0f0f",
    padding: "20px",  
  },
  logo: { display: "flex", alignItems: "center", gap: "10px", marginBottom: "32px" },
  logoIcon: { fontSize: "32px" },
  logoText: { fontSize: "26px", fontWeight: "700", color: "#2ec4b6", letterSpacing: "-0.5px" },
  title: { fontSize: "26px", fontWeight: "700", color: "#e8f5f5", marginBottom: "8px", letterSpacing: "-0.5px" },
  sub: { fontSize: "15px", color: "#5a8a8a", marginBottom: "32px", lineHeight: "1.6" },
  form: { display: "flex", flexDirection: "column", gap: "20px" },
  field: { display: "flex", flexDirection: "column", gap: "8px" },
  label: { fontSize: "14px", fontWeight: "500", color: "#5a8a8a" },
  input: {
    background: "#162424", border: "1px solid #1e3333", borderRadius: "10px",
    padding: "14px 16px", color: "#e8f5f5", fontSize: "16px", outline: "none", width: "100%",
  },
  btn: {
    background: "linear-gradient(135deg, #2ec4b6, #1a9e92)",
    color: "#0a0f0f", border: "none", borderRadius: "10px",
    padding: "16px", fontSize: "16px", fontWeight: "700", width: "100%",
  },
  footer: { textAlign: "center", marginTop: "28px", fontSize: "15px", color: "#5a8a8a" },
  link: { color: "#2ec4b6", textDecoration: "none", fontWeight: "600" },
  successBox: { textAlign: "center" },
  successIcon: { fontSize: "48px", marginBottom: "16px" },
  backBtn: {
    display: "inline-block", marginTop: "24px",
    background: "linear-gradient(135deg, #2ec4b6, #1a9e92)",
    color: "#0a0f0f", borderRadius: "10px", padding: "14px 32px",
    textDecoration: "none", fontWeight: "700", fontSize: "15px",
  },
  page: {
  minHeight: "100vh",
  background: "#0a0f0f",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "20px",
  boxSizing: "border-box",
},
card: {
  width: "100%",
  maxWidth: "440px",
  background: "#0f1a1a",
  borderRadius: "20px",
  overflow: "hidden",
  border: "1px solid #1e3333",
  boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
},
submitBtn: {
  background: "linear-gradient(135deg, #21bdae, #1a9e92)",
  color: "#0a0f0f",
  border: "none",
  borderRadius: "12px",
  padding: "16px",
  fontSize: "16px",
  fontWeight: "700",
  cursor: "pointer",
  width: "100%",
  marginBottom: "20px",
  boxSizing: "border-box",
},
formSection: {
  padding: "12px 32px 40px",
  boxSizing: "border-box",
},
};